module.exports = new __parcel__URL__("paw-color-icon.aa5e7c89.svg").toString();